
function TVplayer(objects) {

    this.objects = objects;
    this.player = null;
    this.loaded = false;

    var self = this;
    this.objects.controls.close.click(function() { self.close(); });
}

TVplayer.prototype.close = function() {
    this.objects.thumb.removeClass('thumb-active');
    this.objects.pImage.css('opacity', 1);
    this.objects.container.hide();
    this.objects.endedOverlay.hide();
    this.pause();
};

TVplayer.prototype.play = function() {
    if(!this.player) {
        return;
    }
    this.objects.endedOverlay.hide();
    this.player.play();
};

TVplayer.prototype.pause = function() {
    if(!this.player) {
        return;
    }
    this.player.pause();
};

TVplayer.prototype.mute = function() {
    if(!this.player) {
        return;
    }
    this.player.mute();
};

TVplayer.prototype.setReady = function(player, mute) {
    this.player = player;
    if(mute) {
        this.player.mute();
    }
};

TVplayer.prototype.setComplete = function() {
    //this.objects.thumb.removeClass('thumb-active');
    //this.objects.pImage.css('opacity', 1);
    //this.objects.container.hide();
    this.objects.endedOverlay.show();
};

TVplayer.prototype.setLoaded = function() {
    if(this.loaded) {
        return;
    }
    this.loaded = true;
    this.objects.loadingOverlay.hide();
};

TVplayer.prototype.hasLoaded = function() {
    return this.loaded;
};